<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">房间：</span>
        </div>
        <input-tree :fetch="fetchDetail" :maxDepth="4" :showPopBox="true" @input="getRoomList" :theValue="roomInfoCode" :theName="roomInfoNumber" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {jurisdiction} from '../../../utils/jurisdiction'
  import {api} from '../../api/agent'
  import {treeApi} from '../../api/TreeApi'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import {pattern} from '../../../utils/regular'
  import InputTree from '../../../components/common/inputs/input-tree'

  export default {
    components: {
      InputTree,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'agent-house-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧经纪',
          name: 'investment-manage'
        }, {
          value: '房源管理'
        }],
        mainTitle: '发布房源',
        subheading: '',


        buildingList: [],
        authTreeData: [],

        roomInfoCode: [],
        roomInfoNumber: [],

        fetchDetail () {
          let treeList = []
          let yqCode = ''

          return treeApi.getYqInfo()
            .then(yqData => {
              let yqObj = {}
              yqCode = yqData.yqCode
              yqObj._value = yqData.yqCode
              yqObj._label = yqData.yqName
              yqObj.parentCode = '0'
              yqObj.level = 1
              yqObj.code = yqData.yqCode
              treeList.push(yqObj)

              treeApi.getAllRoomInfoList()
                .then(roomList => {
                  roomList.map(room => {
                    let roomObj = {}
                    roomObj._value = room.code
                    roomObj._label = room.roomNumber
                    roomObj.buildingName = room.buildingName
                    roomObj.parentCode = room.floorCode
                    roomObj.level = 4
                    roomObj.code = room.code
                    roomObj.roomArea = room.roomArea
                    roomObj.roomRent = room.roomRent
                    roomObj.roomType = room.roomType
                    treeList.push(roomObj)
                  })
                })

              treeApi.getBuildingList()
                .then(buildingList => {
                  buildingList.map(v => {
                    let obj = {}
                    obj._value = v.code
                    obj._label = v.name
                    obj.parentCode = yqCode
                    obj.level = 2
                    obj.code = v.code
                    treeList.push(obj)
                    if (v.floors.length > 0) {
                      v.floors.map(floor => {
                        let floorObj = {}
                        floorObj._value = floor.code
                        floorObj._label = floor.name
                        floorObj.parentCode = floor.buildingCode
                        floorObj.level = 3
                        floorObj.code = floor.code
                        treeList.push(floorObj)
                      })
                    }
                  })

                })
              return treeList
            })
        },
      }
    },
    created () {
      // this.getBuildingList()
    },
    methods: {
      toManagePage () {
        this.$router.push({
          name: 'agent-house'
        })
      },

      getRoomList (roomNameStr, roomCodeStr, roomAreaStr, theData) {
        this.roomInfoCode = roomCodeStr
        this.roomInfoNumber = roomNameStr
      },
      // 确认添加
      confirm () {
        if (!this.roomInfoCode) {
          nError('请选择房间')
          return false
        }
        let roomArr = []
        let roomInfoCodeArr = this.roomInfoCode.split(',')
        let roomInfoNumberArr = this.roomInfoNumber.split(',')
        roomInfoCodeArr.map((v, i) => {
          let obj = {}
          obj.code = v
          obj.roomNumber = roomInfoNumberArr[i]
          roomArr.push(obj)
        })
        this.$axios.post(api.addRoom, roomArr)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('发布成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('发布失败'))
      },
      cancel () {
        this.toManagePage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/agentHouse/agentHouseAdd.vue